import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { ReactNode, memo } from 'react';
import { TypographyOverflow } from '../../common/components/TypographyOverflow';

type Props = {
  title?: string;
  subtitle?: ReactNode;
  rightSection?: ReactNode;
  margin?: boolean;
  loading?: boolean;
};

export const PageTitle = memo(({ title, subtitle, rightSection, margin, loading }: Props) => {
  if (!title && !rightSection && !loading) {
    return null;
  }
  return (
    <Stack
      sx={{ pt: 2, mb: margin ? 2 : 0, width: 1 }}
      gap={2}
      flexWrap="wrap"
      alignItems={{ xs: 'stretch', md: 'center' }}
      justifyContent="space-between"
      direction={{ xs: 'column', md: 'row' }}
    >
      {loading && <Skeleton width={200} height={40} variant="text" />}
      {!loading && (
        <Box sx={{ flex: 1, maxWidth: '100%' }}>
          <TypographyOverflow variant="h4" component="h1" role="heading" aria-level={1}>
            {title}
          </TypographyOverflow>
          {subtitle && (
            <Typography sx={{ color: 'text.primary', mt: typeof subtitle === 'string' ? 1.5 : 0 }} role="heading" aria-level={2}>
              {subtitle}
            </Typography>
          )}
        </Box>
      )}
      {rightSection}
    </Stack>
  );
});
